import axios from "axios";
import { API_BASE_CMS, API_BASE_IMG_URl } from "helper/environment";

export interface NewsletterDoc {
  id: string;
  description: string;
  fileUrl: string;
  iconClass: string;
  iconImg: string;
}

export interface NewsletterData {
  title: string;
  subtitle: string;
  lettertext:string;
  downloadButton?: string;
   description: string;
  documents: NewsletterDoc[];
}

const API_URL = `${API_BASE_CMS}/jsonapi/node/newsletter_journal?include=
field_newsletter_documents,
field_newsletter_documents.field_document_img,
field_newsletter_documents.field_document_img.field_media_image,
field_newsletter_documents.field_document_link,
field_newsletter_documents.field_document_link.field_media_document`;



const DRUPAL_PDF_ICON =
  `${API_BASE_CMS}/sites/default/files/styles/media_library_square_thumbnail/public/2026-01/pdf-icon.png.webp`;

export const fetchNewsletter = async (): Promise<NewsletterData> => {
  const res = await axios.get(API_URL, {
    headers: { Accept: "application/vnd.api+json" },
  });

  const node = res.data.data[0];
  const included: any[] = res.data.included || [];

  /* ================= HELPERS ================= */

  const findIncluded = (type: string, id?: string) =>
    included.find((i) => i.type === type && i.id === id);

  const resolveFileUrl = (fileRel: any): string | null => {
    const file = findIncluded("file--file", fileRel?.id);
    return file?.attributes?.uri?.url
      ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
      : null;
  };

  /* ================= DOCUMENTS ================= */

  const documents: NewsletterDoc[] =
    node.relationships.field_newsletter_documents.data
      .map((paraRel: any) => {
        const para = findIncluded(
          "paragraph--newsletter_journal",
          paraRel.id
        );
        if (!para) return null;

        /* ---------- PDF FILE ---------- */
        const mediaDocRel =
          para.relationships?.field_document_link?.data;
        const mediaDoc = findIncluded(
          "media--document",
          mediaDocRel?.id
        );
        if (!mediaDoc) return null;

        const fileRel =
          mediaDoc.relationships?.field_media_document?.data;
        const fileUrl = resolveFileUrl(fileRel);
        if (!fileUrl) return null;

        /* ---------- ICON IMAGE (JPG/PNG FROM DRUPAL) ---------- */
        let iconImg = DRUPAL_PDF_ICON;

        const iconRel =
          para.relationships?.field_document_img?.data;
        if (iconRel) {
          const iconMedia = findIncluded("media--image", iconRel.id);
          const iconFileRel =
            iconMedia?.relationships?.field_media_image?.data;
          const resolvedIcon = resolveFileUrl(iconFileRel);
          if (resolvedIcon) iconImg = resolvedIcon;
        }

        /* ---------- CONTENT ---------- */
        const rawContent =
          para.attributes?.field_document_content?.value || "";

    


        return {
          id: para.id,
          description : rawContent,
          fileUrl,
          iconClass:
            para.attributes?.field_document_class || "fa fa-download",
          iconImg,
        };
      })
      .filter(
        (i: NewsletterDoc | null): i is NewsletterDoc => i !== null
      );

  /* ================= RETURN ================= */

  return {
    description: node?.attributes?.field_newsletter_title.value || "",
    title: node.attributes.field_main_title || "",
    downloadButton: node.attributes.field_download_button_name || "",
    lettertext: node.attributes.field_letter_text || "",
    subtitle: node.attributes.field_subtitle || "",
    documents,
  };
};
